export const appendJsonKey = (result: any) => `JSONKEY${JSON.stringify(result)}`;
